import { Sidemenu } from '@chillibean/component-library/legacy';
import PropTypes from 'prop-types';

import Navigator from './Navigator';

function Reporting(props) {
  const { formTemplateEnabled, sitesEnabled } = props;

  const navLinks = [
    {
      label: 'Assets Reporting',
      hyperLink: '/assets',
      iconIdentifier: 'fileCopy',
      hyperLinkExactMatch: false,
    },
    {
      label: 'Forms Reporting',
      hyperLink: '/forms',
      iconIdentifier: 'renameBox',
      hyperLinkExactMatch: false,
      disabled: !formTemplateEnabled,
      tooltipText: formTemplateEnabled ? '' : 'Form Templates are not currently enabled on this trial',
    },
    {
      label: 'Sites Reporting',
      hyperLink: '/site',
      iconIdentifier: 'roundAddLocation',
      hyperLinkExactMatch: false,
      disabled: !sitesEnabled,
      tooltipText: sitesEnabled ? '' : 'Sites are not currently enabled on this trial',
    },
  ];

  return (
    <div className="reporting">
      <Sidemenu links={navLinks} returnLink={window.location.origin} />
      <Navigator />
    </div>
  );
}

Reporting.propTypes = {
  formTemplateEnabled: PropTypes.bool.isRequired,
  sitesEnabled: PropTypes.bool.isRequired,
};

export default Reporting;
